// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flag-icon[data-v-3af36db1] {\n  width: 20px !important;\n  line-height: 16px !important;\n  border-radius: 2px !important;\n}\n.v-card[data-v-3af36db1] {\n  transition: all 0.2s ease-in-out;\n}\n", ""]);
// Exports
module.exports = exports;
